import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';
import { ModalAlteracaoAssociacaoService } from './modal-alteracao-assoaciacao.service';
import { NotificationsService } from 'angular2-notifications';
import { HttpParams } from '@angular/common/http';
import { SpringDatatablePagination } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { DocumentoHelper } from '../../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-modal-alteracao-associacao',
  templateUrl: './modal-alteracao-associacao.component.html',
  styleUrls: ['./modal-alteracao-associacao.component.scss']
})
export class ModalAlteracaoAssociacaoComponent implements OnInit {

  @Input() razaoSocial: string;
  @Input() cnpjCpf: string;
  @Input() cadastrar: string;
  @Input() editar: string;

  @ViewChild('card', { static: true })
  private card: ElementRef;
  public formAssociarCartao = null;
  /** Auxiliar de máscara para o CPF/CNPJ no fluxo de cadastro. */
  public cnpjCpfMaskAux = null;
  public tipo = null;
  public percentualParceiro = null;
  public percentualEmpresa = null;
  public modalEdit = false;
  public modalCadastrar = false;
  public tipoDado = null;
  public status = null;
  public page = null;
  public tableLimit = "20";
  public customLogin = null;

  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  constructor(
    private formBuilder: FormBuilder,
    protected ref: NbDialogRef<ModalAlteracaoAssociacaoComponent>,
    private service: ModalAlteracaoAssociacaoService,
    private notifications: NotificationsService,
    private paginationService: SpringDatatablePaginationService,
  ) {

    this.tipo = [
      {
        status: 'ATIVO',
        descricao: 'ATIVO'
      },
      {
        status: 'INATIVO',
        descricao: 'INATIVO'
      },
      {
        status: 'SUSPENSO',
        descricao: 'SUSPENSO'
      },

    ];

    this.formAssociarCartao = this.formBuilder.group({
      razaoSocial: [null],
      cnpjCpf: [null],
      percentualEmpresa: [null],
      percentualParceiro: [null],
      status: [null],
      nomeFantasia: [null]
    });

  }

  calculoPercentual(data) {

    if (data != null) {

      const charCode = (data.which) ? data.which : data.keyCode;
      if ((charCode != 0) && (charCode != 8) && (charCode != 13)) {
        if (!RegExp(/[0-9]/gi).test(String.fromCharCode(charCode))) return false;
        if (parseInt(data.target.value + String.fromCharCode(charCode)) > 100) return false;
      }

    }

  }

  calculoResidual(data) {

    this.percentualParceiro = 100 - data;
    this.formAssociarCartao.controls['percentualParceiro'].setValue(this.percentualParceiro);

  }

  voltar() {

    this.ref.close();
  }

  saveCard(data) {

    if (data.status != null) {

      this.status = data.status;
      this.tipoDado = "ATUALIZACAO";

    } else {

      this.status = "ATIVO";
      this.tipoDado = "NOVO";
      this.cnpjCpf = data.cnpjCpf;

    }

    const docNorm = this.normalizarCnpjCpfParaBackend(
      data.cnpjCpf != null && String(data.cnpjCpf).trim() !== ''
        ? data.cnpjCpf
        : this.cnpjCpf,
    );

    let register = {

      cnpj: docNorm,
      percentualEmpresa: data.percentualEmpresa,
      percentualParceiro: data.percentualParceiro,
      status: this.status,
      tipoDado: this.tipoDado,

    };

    this.service.partnerSearch(
      register,
      (response) => {

        this.notifications.success(response.message);
        this.buscarUser(this.formAssociarCartao.value);
        this.ref.close();

      }, (error) => {
        this.notifications.error(error.message);
      });

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    if (this.card && this.card.nativeElement && this.card.nativeElement.ownerDocument) {
      const ae = this.card.nativeElement.ownerDocument.activeElement;
      if (ae && typeof ae.blur === 'function') {
        ae.blur();
      }
    }
    this.formAssociarCartao.controls['percentualParceiro'].setValue(null);
    const rawFromInput = this.normalizarCnpjCpfParaBackend(this.cnpjCpf);
    if (rawFromInput !== '') {
      this.formAssociarCartao.controls['cnpjCpf'].setValue(rawFromInput);
      this.cnpjCpfMaskAux = rawFromInput;
    } else {
      this.cnpjCpfMaskAux = null;
    }
    this.formAssociarCartao.controls['razaoSocial'].setValue(this.razaoSocial);


    if (this.cadastrar == "CADATRAR") {

      this.modalCadastrar = true;
      this.modalEdit = false;

    } else {

      this.modalEdit = true;
      this.modalCadastrar = false;

    }

  }

  buscarEmpresa(data) {

    let params = new HttpParams();

    const docNorm = this.normalizarCnpjCpfParaBackend(data.cnpjCpf);
    if (docNorm !== '') {
      params = params.append('cnpjCpf', docNorm);
    }

    this.service.enterpriseListByCnpj(params, (response) => {

      this.formAssociarCartao.controls['nomeFantasia'].setValue(response.nomeFantasia);

    }, null);

  }

  buscarUser(data: any, page?: any) {

    let params = new HttpParams();

    if (data != null) {

      if (data.status != null && String(data.status).trim() !== '') {
        params = params.append('status', data.status);
      }
      const docNorm = this.normalizarCnpjCpfParaBackend(data.cnpjCpf);
      if (docNorm !== '') {
        params = params.append('cnpjCpf', docNorm);
      }
      if (data.nomeFantasia != null && String(data.nomeFantasia).trim() !== '') {
        params = params.append('nomeFantasia', data.nomeFantasia);
      }

    }

    const pageParam =
      page != null && page !== undefined && page !== '' && !isNaN(Number(page))
        ? Number(page)
        : 1;
    params = params.append('page', String(pageParam));

    params = params.append('size', String(this.tableLimit));

    this.service.partner(params, (response => {

      this.datatablePagination.rowData = response.list;
      this.paginationService.setInfo(response);

    }), error => {

      this.notifications.error(error.message);


    });

  }

  getCpfCnpjMask(): string {
    const ctrl = this.formAssociarCartao && this.formAssociarCartao.get('cnpjCpf');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpjCpfMaskAux != null && String(this.cnpjCpfMaskAux).trim() !== ''
        ? this.cnpjCpfMaskAux
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str === '') {
      return '';
    }
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

}
